<agpr-message
    *ngIf="infoMessage && totalUsagePercentage <= threshold && !(remainingThreshold && remainingCount <= remainingThreshold)"
    [severity]="messageSeverities.info"
>
    <p [innerHTML]="infoMessage"></p>
    <ng-content select=".infoLink"></ng-content>
</agpr-message>

<agpr-message
    *ngIf="warningMessage && totalUsagePercentage < 100
        && (totalUsagePercentage > threshold || (remainingThreshold && remainingCount <= remainingThreshold))"
    [severity]="messageSeverities.warning"
>
    <p [innerHTML]="warningMessage"></p>
    <ng-content select=".warningLink"></ng-content>
</agpr-message>

<agpr-message
    *ngIf="errorMessage && totalUsagePercentage >= 100"
    [severity]="messageSeverities.error"
>
    <p [innerHTML]="errorMessage"></p>
    <ng-content select=".errorLink"></ng-content>
</agpr-message>